<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group :horizontal="true">
          <multiselect
            :placeholder="customPlaceholder"
            v-model="selected"
            :options="formOptions"
            label="name"
            trackBy="id"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "AddOnSelect",
  components: { Multiselect },
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectedItem: {
      type: String,
      default: "",
    },
    customPlaceholder: {
      type: String,
      default: "",
    },
  },
  computed: {
    formOptions() {
      if (this.options.options && this.options.options.length) {
        if (this.options.field === "cropstage") {
          return this.options.options;
        } else {
          return this.options.options.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
          );
        }
      } else {
        return [];
      }
    },
    selected: {
      get() {
        return (
          (this.selectedItem &&
            this.options.options &&
            this.options.options.find(
              (option) => option.id === this.selectedItem
            )) ||
          null
        );
      },
      set(value) {
        this.$emit("change", {
          selected: (value && value.id) || null,
          field: this.options.field,
        });
      },
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
